import { VIEWS_MAP } from '../../../router/constants';

export const STYLES = {
  APP_LAYOUT: {
    LAYOUT:
      'bg-bw02 h-screen pl-[10rem] pc-sm:pl-[22.188rem] pc-md-lg:pl-[22.5rem] pt-[3.688rem] pb-20 w-[72rem] pc-sm:w-[80.5rem] pc-md-lg:w-[93rem] flex flex-col',
    TITLE: 'font-metricMedium text-xl',
    NAV: 'h-[2rem] mt-5 mb-[1.5rem]',
  },
  ICON: 'w-[88px] mb-[22px]',
  HEADING: 'mb-[22px] font-metricMedium text-[25px] text-bw08',
  MAIN_CONTENT_WRAPPER:
    'relative flex flex-col p-[40px] pt-[64px] bg-bw00 rounded-lg w-[540px] max-h-[65.6vh] min-h-[548px]',
  STEP: {
    CONTENT_WRAPPER: 'flex flex-col',
    INNER_CONTENT_WRAPPER: 'flex items-center',
    HEADING: 'leading-[1rem] mb-[8px] font-metric text-[14px] text-bw07',
    REGULAR_CONTENT: 'font-metric text-sm text-bw06 mr-[4px]',
    BOLDED_CONTENT: 'font-metricMedium text-sm text-bw06',
  },
  TRACKER_ACTIONS: {
    CONTAINER: 'mt-auto flex items-center justify-center w-full',
    SHIPPING: {
      CONTAINER: 'flex items-center',
      HEADING: 'font-metric text-bw07 text-[1rem] mr-[4px]',
    },
    ACTIVATION_REQUIRED: {
      CONTAINER: 'flex flex-col justify-center items-center',
    },
    NEEDS_FUND: {
      CONTAINER: 'flex flex-col justify-center items-center',
    },
  },
};

export const TEXTS = {
  HEADING: 'CARD_TRACKER_VIEW_HEADER',
  ROUTE_TITLE: 'CARD_TRACKER_ROUTE_TITLE',
  TRACKER_ACTIONS: {
    SHIPPING: {
      HEADING: 'CARD_TRACKER_ACTION_SHIPPING_HEADER',
    },
  },
} as const;

export const IDS = {
  TRACKER_ACTIONS: {
    CTA_1: 'trackerActionCta1',
    CTA_2: 'trackerActionCta2',
  },
} as const;

export const CARD_PRETTY_STATUS = {
  UNKNOWN: 0,
  RETURN_TO_SENDER: 1,
  NEEDS_FUND: 2,
  CARD_ON_PRINT: 3,
  ACTIVATION_REQUIRED: 4,
  ACTIVE: 5,
  SHIPPING: 6,
};

export const SHIPPING_STATUS = {
  SHIPPED: 'shipped',
  RTS: 'returnedToSender',
};

export const PROGRESS_STEPS = [
  {
    title: 'CARD_TRACKER_STEPS.PENDING_FUNDING.TITLE',
    statusRef: 2,
    content: 'CARD_TRACKER_STEPS.PENDING_FUNDING.CONTENT',
    appearOnActive: true,
    actions: [
      {
        title: 'CARD_TRACKER_STEPS.PENDING_FUNDING.ACTION_1_TITLE',
        styles: 'rounded-[3px] font-metricMedium text-bw00 text-sm bg-action03 py-[13px] px-[74px]',
        linkUrl: VIEWS_MAP.DIRECT_DEPOSIT,
      },
    ],
  },
  {
    title: 'CARD_TRACKER_STEPS.PRINTING.TITLE',
    statusRef: 3,
    content: 'CARD_TRACKER_STEPS.PRINTING.CONTENT',
    appearOnActive: false,
    actions: [],
  },
  {
    title: 'CARD_TRACKER_STEPS.SHIPPING.TITLE',
    statusRef: 6,
    content: 'CARD_TRACKER_STEPS.SHIPPING.CONTENT',
    appearOnActive: false,
    actions: [
      {
        title: 'CARD_TRACKER_STEPS.SHIPPING.ACTION_1_TITLE',
        styles: 'font-metric text-action03 text-[1rem]',
        linkUrl: '/activate-card/:tracked',
      },
    ],
  },
  {
    title: 'CARD_TRACKER_STEPS.ACTIVATION.TITLE',
    statusRef: 4,
    content: 'CARD_TRACKER_STEPS.ACTIVATION.CONTENT',
    appearOnActive: false,
    actions: [
      {
        title: 'CARD_TRACKER_STEPS.ACTIVATION.ACTION_1_TITLE',
        styles: 'rounded-[3px] mb-[12px] font-metricMedium text-bw00 text-sm bg-action03 py-[13px] px-[74px]',
        linkUrl: '',
      },
      {
        title: 'CARD_TRACKER_STEPS.ACTIVATION.ACTION_2_TITLE',
        styles: 'font-metric text-action03 text-sm',
        linkUrl: '/activate-card/:tracked',
      },
    ],
  },
];
